import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useComplianceData } from '../../hooks/useComplianceData';
import s from '../../styles/Compliance.module.css';

const ComplianceAgencyList: React.FC = () => {
  const { agencies, agenciesLoading, fetchAgencies } = useComplianceData();
  const navigate = useNavigate();

  useEffect(() => { fetchAgencies(); }, [fetchAgencies]);

  return (
    <div className={s.page}>
      <h2 className={s.pageTitle}>🏢 Agencies</h2>
      <section className={s.panel}>
        <h3 className={s.panelTitle}>All Agencies ({agencies.length})</h3>
        {agenciesLoading ? <p className={s.loading}>Loading…</p> : (
          <div className={s.tableWrapper}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Trading As</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {agencies.map(a => (
                  <tr key={a.id}>
                    <td>{a.company_name}</td>
                    <td>{a.trading_as_name ?? '—'}</td>
                    <td>{a.archived ? 'Archived' : 'Active'}</td>
                    <td className={s.actions}>
                      <button className={s.btnEdit} onClick={() => navigate(`/compliance/agencies/${a.id}`)}>
                        Open
                      </button>
                    </td>
                  </tr>
                ))}
                {agencies.length === 0 && (
                  <tr><td colSpan={4} className={s.empty}>No agencies found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default ComplianceAgencyList;
